/**
 * ProdEng data loader
 * Isolates JSON import to prevent source map position shifts
 */
import prodengManifest from '@/content/prodeng/prodeng-manifest.json';

export { prodengManifest };

/** Format YYYY-MM-DD frontmatter dates in local time (avoid UTC-midnight off-by-one). */
export function formatProdengDate(
  date: string,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' },
): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(date);
  if (!match) return date;
  const local = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return local.toLocaleDateString('en-US', options);
}
